// extracted by mini-css-extract-plugin
export var printerCard = "_ax-1";
export var printerCardConfigured = "_ax-2";
export var printerCardError = "_ax-3";
export var printerCardsContainer = "_ax-0";
export var printerIcon = "_ax-8";
export var printerIconConfigured = "_ax-5";
export var printerIconContainer = "_ax-4";
export var printerIconError = "_ax-6";
export var printerIconUnconfigured = "_ax-7";
export var workstationsTableCard = "_ax-9";